import { laptopSmallMax, laptopSmallMin } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';
import { SmallHeading, Text } from '../typography';

const textBreakpoint1 = 1120;
const textBreakpoint2 = 550;

const textBpMax = `max-width: ${textBreakpoint1}px`;
const textBpMin = `min-width: ${textBreakpoint1 + 1}px`;
const textMobBpMax = `max-width: ${textBreakpoint2}px`;
const textMobBpMin = `min-width: ${textBreakpoint2 + 1}px`;

const GAP = 30;
const SPACE = -(GAP / 2);

export const Container = styled.section`
  padding: 65px 20px 110px 20px;
`;

export const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 1180px;
`;

export const DisplayTypes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 100px;
`;

export const DisplayType = styled.div`
  display: flex;
  gap: 60px;
  flex-direction: column-reverse;

  @media (${laptopSmallMin}) {
    align-items: center;
    justify-content: space-between;
    gap: 80px;

    &:nth-child(even) {
      flex-direction: row-reverse;
    }
    &:nth-child(odd) {
      flex-direction: row;
    }

    & > :nth-child(1),
    > :nth-child(2) {
      flex-basis: 50%;
      width: 50%;
    }
  }
`;

export const Mockup = styled.div`
  display: flex;
  justify-content: center;
`;

export const MockupImg = styled.img<{ maxW?: number }>`
  width: 100%;
  ${({ maxW }) =>
    maxW
      ? css`
          max-width: ${maxW}px;
        `
      : ''}

  @media (${laptopSmallMax}) {
    max-width: 500px;

    ${({ maxW }) =>
      maxW
        ? css`
            max-width: 220px;
          `
        : ''}
  }
`;

export const DisplayTypeContent = styled.li`
  display: flex;
  gap: 10px;
`;

export const DisplayNumber = styled.div<{ mob?: boolean }>`
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.white};
  width: 32px;
  height: 32px;
  flex-basis: 32px;
  align-items: center;
  justify-content: center;
  text-align: center;
  align-self: flex-start;
  border-radius: 100%;
  font-size: 20px;
  font-weight: 800;
  line-height: 1;

  display: ${({ mob }) => (mob ? 'flex' : 'none')};

  @media (${laptopSmallMin}) {
    display: ${({ mob }) => (mob ? 'none' : 'flex')};
  }
`;

export const DisplayDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  flex: 1;

  & > ${Text} {
    font-size: 20px;
    font-weight: bold;
    line-height: 1.6;

    @media (${laptopSmallMax}) {
      align-self: center;
    }
  }
`;

export const DisplayFeatures = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 15px;

  @media (${textBpMin}), (${laptopSmallMax}) and (${textMobBpMin}) {
    flex-direction: row;
    gap: ${GAP}px;
  }
`;

export const DisplayFeature = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${GAP / 2}px;
  flex-basis: 33.3333%;
  position: relative;

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    background-color: ${({ theme }) => theme.backgroundLight};
  }

  ${SmallHeading} {
    font-weight: bold;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  ${Text}, li {
    color: ${(props) => props.theme.textDark};
  }

  @media (${textBpMax}) and (${laptopSmallMin}), (${textMobBpMax}) {
    &:not(:last-child)::after {
      left: 0;
      bottom: ${SPACE / 2}px;
      right: 0px;
      width: 100%;
      height: 1px;
    }
  }

  @media (${textBpMin}), (${laptopSmallMax}) and (${textMobBpMin}) {
    &:not(:last-child)::after {
      top: 0;
      bottom: 0;
      right: ${SPACE}px;
      width: 1px;
      height: 100%;
    }
  }

  @media (${laptopSmallMax}) {
    align-items: center;
    text-align: center;
  }
`;
